var map = {
	"./logo-big-picture-medical-mark.svg": "a7a4",
	"./logo-big-picture-medical-regular.svg": "d2e8",
	"./logo-jnj-mark.svg": "91d4",
	"./logo-jnj-regular.svg": "b2af",
	"./logo-menicon-mark.svg": "5b2d",
	"./logo-menicon-regular.svg": "86f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7f8";